export default {
  tags: 'Tag',
};
